import PropTypes from 'prop-types';
import React from 'react';

const InputField = ({
  className,
  disabled,
  id,
  isValid,
  name,
  placeholder,
  required,
  type,
  value,
  min,
  max,
  style,
  onChange,
  onClick,
  onInput,
  onBlur,
  onFocus,
  validations,
  disableCopyPaste
}) => (
  <input
    className={className}
    disabled={disabled}
    id={id}
    min={min}
    max={max}
    name={name}
    onChange={onChange}
    onClick={onClick}
    onInput={onInput}
    onBlur={onBlur}
    onFocus={onFocus}
    placeholder={placeholder}
    required={required}
    validations={validations}
    onPaste={disableCopyPaste ? e => e.preventDefault() : null}
    onDrop={disableCopyPaste ? e => e.preventDefault() : null}
    autoComplete={disableCopyPaste ? 'off' : null}
    style={{
      ...style,
      borderColor: isValid
        ? style && style.borderColor ? style.borderColor : null
        : 'red',
    }}
    type={type}
    {...(type === 'tel' ? {pattern: '^[0-9-+\s()]*$'} : {})}
    value={value}
  />
);

InputField.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  isValid: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onInput: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  style: PropTypes.object,
  type: PropTypes.oneOf([
    'email',
    'number',
    'password',
    'tel',
    'text',
    'url',
    'hidden',
  ]),
  value: PropTypes.string,
  validations: PropTypes.object,
  disableCopyPaste: PropTypes.bool
};

InputField.defaulProps = {
  isValid: true,
  type: 'text',
  value: '',
};

export default InputField;
